

























































































































import { obrigatorio } from "@/shareds/regras-de-form"
import type { FiltroDePedido} from '@/models'
import { Component, PropSync, Ref, Vue } from "vue-property-decorator"
import { nextTick } from '@/shareds/utils'
import RangeDatePicker from "@/components/ui/RangeDatePicker.vue"
import { limparFiltroDosCamposDePedidos } from "@/shareds/venda-shareds"
import SeletorDeCliente from "../clientes/SeletorDeCliente.vue"
import SeletorDeCanalDeVendas from "@/components/ui/SeletorDeCanalDeVendas.vue"

@Component({
	components:{
		SeletorDeCliente,
		RangeDatePicker,
		SeletorDeCanalDeVendas,
	},
})

export default class CamposFiltroDePedidos extends Vue {
	@PropSync('value',{
		default: () => ({
			datas: [],
			cliente: '',
			ambientes: '',
			situacao: [],
			lojaId: null,
			possuiFrete: false,
			canalDeVendasId: null,
		}),
	}) filtro!: FiltroDePedido
	@Ref() form!: HTMLFormElement

	dataVenda = []
	mostra = false
	buscando = false
	identificador = ''
	obrigatorio = obrigatorio

	mostrar(){
		this.mostra = true
	}

	ocultar(){
		this.mostra = false
	}

	async aplicarFiltro() {
		await nextTick()
		if(!this.form.validate()) return
		this.$emit('buscar', this.filtro)
	}

	limparFiltros(){
		this.$emit('limpar')
		this.$emit('input', limparFiltroDosCamposDePedidos())
	}

	handlePossuiFrete(){
		if(this.filtro.possuiFrete){
			this.filtro.retiradaNaLoja = false;
		}
	}

	handleRetiradaNaLoja(){
		if(this.filtro.retiradaNaLoja){
			this.filtro.possuiFrete = false;
		}
	}
}
